import { useRef, useState } from "react";
import SearchFilterComponent from "../../Common/SearchFilterComponent/SearchFilterComponent";
import styles from "./index.module.scss";
import TagsTable from "./tags-table";

const TagsPage = () => {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [searchValue, setSearchValue] = useState('');

  const handleSearchOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const handleSearchOnCross = () => {
    setSearchValue('');
  };


  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <SearchFilterComponent
          leftSide={
            <div>
              <span className="f-16 line-height-24 f-600 f-black">
                Tags
              </span>
            </div>
          }
          searchValue={searchValue}
          searchOnChange={handleSearchOnChange}
          searchOnCross={handleSearchOnCross}
          passedRef={searchInputRef}
          setRef={() => {
            searchInputRef.current?.focus();
          }}
          lastButtonLabel="Add"
        />
        <TagsTable />
      </div>
    </div>
  );
};

export default TagsPage;
